import styles from '../../ProjectStoryMapBoard.module.css'

const BoardEmptyState = ({ readOnly = false }) => (
    <div className={styles.boardEmptyState}>
        <h2 className={styles.boardEmptyStateTitle}>
            {readOnly ? 'This story map is empty' : "Let's get started..."}
        </h2>
        <p className={styles.boardEmptyStateText}>
            {readOnly
                ? 'There are no journeys on this story map yet.'
                : (
                    <>
                        To start using your story map, try hitting the{' '}
                        <strong>ADD JOURNEY</strong> button above.
                    </>
                  )}
        </p>
    </div>
)

export default BoardEmptyState
